import { render, staticRenderFns } from "./ActivationPlan.vue?vue&type=template&id=653971ba&"
import script from "./ActivationPlan.vue?vue&type=script&lang=js&"
export * from "./ActivationPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports